import React from 'react';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { MdFileDownload, MdEdit, MdSend, MdKeyboardBackspace, MdAssignmentInd } from 'react-icons/md';
import { FaThumbsDown, FaThumbsUp } from 'react-icons/fa';
import { IconButton } from '~/components/crud/styles';
import confirm from '~/components/confirm';
import Spinner from '~/components/spinner';
import DataTable from '~/components/datatable';
import CellStatus from '~/components/datatable/cell-status';
import { FormHeader, FormToolbar, ActionsCell, ApprovalButton, Infos } from '~/views/events/accredit-approval/styles';
import { formats, arrayInsertAt } from '~/helper';

const sortEmployees = (array) => {
  return _.orderBy(array, (r) => _.get(r, 'person.name'), ['asc']);
};

function EmployeesForm({ supplier, loading, exportPersonsXlsx, detail: {summary, employees}, onPressMail, onEdit, onClose, onAction, onCreateCredentials }) {

  let canGenerateCredentials = !!_.find(employees, { status: 'approved' });
  let isPress = _.get(supplier, 'company.isPress');

  const handleExportPersons = async () => {
    const result = await confirm.show({
      title: 'Atenção',
      text: `Deseja exportar uma planilha com os colaboradores desse fornecedor vinculados ao evento?`,
    });

    if (result) {
      exportPersonsXlsx(_.get(supplier, 'company.id'));
    }
  };

  const columns = [
    {
      name: 'CPF/Nº Registro',
      width: '150px',
      selector: 'company',
      cell: (row) => {
        let text = formats.cpf(_.get(row, 'person.identify')) || _.get(row, 'person.identify') || '';
        return (
          <CellStatus title={text} color={_.get(row, 'person.isBlacklist') ? '#222' : '#53d449' }>
            <strong>{text}</strong>
          </CellStatus>
        );
      },
    },
    {
      name: 'Nome',
      selector: 'person',
      format: (row) => _.get(row, 'person.name')
    },
    {
      name: 'Função',
      selector: 'role',
      format: (row) => _.get(row, 'person.role.name')
    },
    {
      name: 'Ações',
      selector: 'status',
      width: '130px',
      center: true,
      format: (row) => {
        return <ActionsCell>
           <ApprovalButton
            title="Editar"
            onClick={() => onEdit(row)}>
            <MdEdit />
          </ApprovalButton>

          <ApprovalButton
            title="Aprovar"
            color={row.status === 'approved' ? '#4db345' : ''}
            onClick={() => onAction(row, 'approve')}>
            <FaThumbsUp />
          </ApprovalButton>

          <ApprovalButton
            title="Aprovar"
            color={row.status === 'reproved' ? '#e6467f' : ''}
            onClick={() => onAction(row, 'reprove')}>
            <FaThumbsDown />
          </ApprovalButton>
        </ActionsCell>
      }
    }
  ];

  if (isPress) {
    arrayInsertAt(columns, 3, { name: 'Nº Cabine/Tribuna', selector: 'cabine' });
    arrayInsertAt(columns, 4, { name: 'Tipo de acesso', selector: 'tribuna' });
  }

  return (
    (loading) ?
      <Spinner visible={true} />
    :
    <>
      <FormHeader>
        {isPress ? 'Imprensa' : 'Fornecedor'} {formats.cnpj(_.get(supplier, 'company.identify')) || _.get(supplier, 'company.identify') || ''}
      </FormHeader>

      <PerfectScrollbar>
        <DataTable
          columns={columns}
          data={{ rows: sortEmployees(employees || []) }}
          noPagination={true}
          emptyText="Nenhum colaborador credenciado"
          onRowClicked={_.noop}
          extraOptions={{
            ignoreRowClicked: true,
            selectableRows: false,
            selectableRowsHighlight: false,
          }}
          />
      </PerfectScrollbar>

      <FormToolbar>
        <Infos>
          <span>Legenda:</span>
          <span className="regular">Regular</span>
          <span className="blacklist">Blacklist</span>
        </Infos>

        <div className='buttons'>
          <IconButton title='Cancelar' onClick={onClose}>
            <MdKeyboardBackspace />
          </IconButton>

          <IconButton title='Baixar planilha com Colaboradores' onClick={handleExportPersons}>
            <MdFileDownload />
          </IconButton>

          {isPress && 
            <IconButton title='Editar todos' onClick={() => onEdit(_.get(supplier, 'company'), 'press')}>
              <MdEdit />
            </IconButton>
          }

          {isPress && 
            <IconButton title='Enviar email' onClick={onPressMail}>
              <MdSend />
            </IconButton>
          }

          <IconButton title='Aprovar Todos' onClick={() => onAction({ blacklist: _.map(_.filter(employees, (r) => _.get(r, 'person.isBlacklist')), 'id') }, 'approveAll')}>
            <FaThumbsUp />
          </IconButton>

          <IconButton title='Reprovar Todos' onClick={() => onAction({}, 'reproveAll')}>
            <FaThumbsDown />
          </IconButton>

          {canGenerateCredentials &&
            <IconButton title='Gerar credenciais' onClick={onCreateCredentials}>
              <MdAssignmentInd />
            </IconButton>
          }
        </div>
      </FormToolbar>
    </>
  );
}

export default EmployeesForm;
